import {initSelects} from "./Select.ts";
import {initChampACompleter, initChampAModifier} from "./FormHelper.ts";
import {$, $$, getParentElementByClassName} from "./Dom.ts";
import {fadeIn} from "./Animate.ts";
import {initHistoriqueList} from "./List.ts";
import {createErrorNotification, createInfoNotification, createNotifications, createSuccessNotification, createWarningNotification} from "./Notifications.ts";
import {date_picker_init} from "./DatePicker.ts";
import {initTooltips} from "./Tooltip.ts";
import {registerModalListener} from "./Modal.ts";
import {initrecherche} from "./eline/recherche.ts";
import {initCkeditorA11y} from "./CkeditorA11y.ts";
import {initUppyPieceJointe} from "./uppy_piece_jointe.ts";


document.addEventListener('DOMContentLoaded', () => {
    // les initialisation globale sont a mettre ici (les tooltip, les select, les datepicker, etc...)
    date_picker_init();
    initTooltips()
    initSelects()
    initChampACompleter()
    initChampAModifier()
    initrecherche()
    exposeNotifications()
    initCkeditorEvent()
    initCkeditorA11y()
    registerModalListener()
    initUppyPieceJointe()


    if (!nav_obselete()) {
        console.log('nav obselete')
        fadeIn($<HTMLElement>('#nav_obselete'))
    }

    $$('.modifier').forEach((element) => getParentElementByClassName(element, 'fr-grid-row')?.classList.add('champ-a-modifier', 'champ'))

    if (document.getElementById('historique-list')) {
        initHistoriqueList()
    }
})

function nav_obselete() {
    let ua = navigator.userAgent
    let is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;
    if (is_ie) {
        return false
    }
    let ok = true
    if (ua.search('Firefox/') !== -1) {
        ok = Number(ua.split('Firefox/')[1]) >= 60
    } else if (ua.search('Chrome/') !== -1) {
        ok = Number(ua.split('Chrome/')[1].split('.')[0]) >= 60
    }
    return ok
}

function exposeNotifications() {
    window.createSuccessNotification = createSuccessNotification
    window.createErrorNotification = createErrorNotification
    window.createInfoNotification = createInfoNotification
    window.createWarningNotification = createWarningNotification
    window.createNotifications = createNotifications
}

function initCkeditorEvent() {
    document.body.addEventListener('ckeditor:updated', (event: any) => {
        const editor = event.detail
        let notesParent = getParentElementByClassName(editor.sourceElement, "form_ajout_note")
        if (!notesParent) {
            notesParent = getParentElementByClassName(editor.sourceElement, 'fr-modal__content')
        }
        if (notesParent) {
            let button = $("button.btnsubmit_note", notesParent!)
            if (!button) {
                button = $('button.btn_submit_dropzone_note_modif', notesParent!)
            }
            const data = editor.getData()
            let emptyChild = 0
            // on peut parcourir les éléments identifier par ckeditor pour verifier s'ils sont vides ou non
            const childs = editor.data.parse(data)._children._nodes
            childs.forEach((child: any) => {
                if (child.isEmpty) emptyChild++
            })
            if (emptyChild !== childs.length) {
                button?.removeAttribute('disabled')
            } else {
                button?.setAttribute('disabled', 'true')
            }
        }
    })
}